import React from "react";
import "./ContentItem.css";

export default function ContentItem({
  children,
  actions,
  className = "",
  as: Component = "article",
  variant = "default",
}) {
  return (
    <Component
      className={["content-item", `content-item--${variant}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="content-item__main">{children}</div>

      {actions && <div className="content-item__actions">{actions}</div>}
    </Component>
  );
}
